import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

const Typography = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Typography" pageType="Elements" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Headings
            </h2>
            <div className="flex flex-col gap-3">
              <h1 className="text-4xl font-semibold text-black dark:text-darkmuted">
                Sliced heading
              </h1>
              <h2 className="text-3xl font-semibold text-black dark:text-darkmuted">
                Sliced heading
              </h2>
              <h3 className="text-2xl font-semibold text-black dark:text-darkmuted">
                Sliced heading
              </h3>
              <h4 className="text-xl font-semibold text-black dark:text-darkmuted">
                Sliced Headings
              </h4>
              <h5 className="text-lg font-semibold text-black dark:text-darkmuted">
                Sliced heading
              </h5>
              <h6 className="text-sm font-semibold text-black dark:text-darkmuted">
                Sliced heading
              </h6>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Font Weight
            </h2>
            <div className="flex flex-col gap-3">
              <p className="text-lg font-light">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-lg font-normal">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-lg font-medium">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-lg font-semibold">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-lg font-bold">Sliced - TailwindCSS Admin & Dashboard</p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text Left
            </h2>
            <div className="ltr:text-left rtl:text-right">
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration in some form, by
                injected humour, or randomised words which don't look even
                slightly believable.
              </p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text Center
            </h2>
            <div className="text-center">
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration in some form, by
                injected humour, or randomised words which don't look even
                slightly believable.
              </p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text Right
            </h2>
            <div className="ltr:text-right rtl:text-left">
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration in some form, by
                injected humour, or randomised words which don't look even
                slightly believable.
              </p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text justify
            </h2>
            <div className="text-justify">
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration in some form, by
                injected humour, or randomised words which don't look even
                slightly believable but the majority have suffered alteration in
                some form, by injected humour.
              </p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text Color
            </h2>
            <div className="flex flex-col gap-3">
              <p className="text-purple">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-info">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-success">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-warning">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-danger">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-black">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-muted">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="text-light">Sliced - TailwindCSS Admin & Dashboard</p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text Decoration
            </h2>
            <div className="flex flex-col gap-3">
              <p className="underline">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="overline">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="line-through">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="underline decoration-double">
                Sliced - TailwindCSS Admin & Dashboard
              </p>
              <p className="underline decoration-wavy">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="underline decoration-4">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="underline decoration-dotted">
                Sliced - TailwindCSS Admin & Dashboard
              </p>
              <p className="underline decoration-dashed">
                Sliced - TailwindCSS Admin & Dashboard
              </p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text Transforming
            </h2>
            <div className="flex flex-col gap-3">
              <p className="normal-case">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="uppercase">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="lowercase">Sliced - TailwindCSS Admin & Dashboard</p>
              <p className="capitalize">Sliced - TailwindCSS Admin & Dashboard</p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text Indent
            </h2>
            <div>
              <p className="indent-10">
                So I started to walk into the water. I won't lie to you boys, I
                was terrified. But I pressed on, and as I made my way past the
                breakers a strange calm came over me. I don't know if it was
                divine intervention or the kinship of all living things but I
                tell you Jerry at that moment, I was a marine biologist.
              </p>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Text Truncate
            </h2>
            <div>
              <p className="overflow-hidden truncate whitespace-nowrap">
                So I started to walk into the water. I won't lie to you boys, I
                was terrified. But I pressed on, and as I made my way past the
                breakers a strange calm came over me. I don't know if it was
                divine intervention or the kinship of all living things but I
                tell you Jerry at that moment, I was a marine biologist.
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Typography;
